<template lang="pug">
    v-card.rounded-lg(flat)
            v-card-title.text-capitalize {{$t("videoDetails.podcast.title")}}
              v-chip.ma-2(outlined x-small dense color="primary") Coming soon
            v-card-subtitle {{$t("videoDetails.podcast.subtitle")}}
            v-card-text 
              audio.rounded-lg(controls='' controlsList="nodownload")
                source(v-if="audioSrc" :src='audioSrc')
                | Your browser does not support the audio element.
</template>
<script>
export default {
  name: "PodcastCard",
  props: ["audioSrc"],
};
</script>
